import { useAppDispatch, useAppSelector } from "app/hooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useLocation, useNavigate } from "react-router-dom";
import { updateImportedGlobalWallets } from "reduxState/globalManagement/globalManagement";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { updateImportedWallets } from "reduxState/wallets/wallets";
import { backendErrors } from "utilities/backendErrors";
import { links } from "utilities/links";
import { WalletTypeForm } from "../WalletTypeForm/WalletTypeForm";
import { useStyles } from "./WalletTypeImportList.styles";

export const EditImportedWalletType = () => {
  const { message } = useMessage();
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const defaultLang = useAppSelector(selectDefaultLanguageData);

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "walletTypesImportReview" }),
      path: links.walletsImportList,
    },
  };

  const initialValues = state.walletData;
  const clearLink =
    state?.importType === "single"
      ? links.walletTypesList
      : links.configDuplicationImport;

  return (
    <>
      <TopHeader
        title={state?.walletData?.translations?.[defaultLang.code].name}
        clearLink={clearLink}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.wrapper}>
        <WalletTypeForm
          initialValues={initialValues}
          initialErrors={backendErrors(state.errors)}
          onSaveCallback={(wallet) => {
            if (state?.importType === "single") {
              dispatch(
                updateImportedWallets({
                  importedId: state.importedId,
                  wallet: wallet,
                }),
              );

              return navigate(links.walletsImportList);
            }

            // GLOBAL IMPORT UPDATE
            dispatch(
              updateImportedGlobalWallets({
                importedId: state.importedId,
                wallet: wallet,
              }),
            );

            return navigate(links.configDuplicationImport);
          }}
          onCancelCallback={() => {
            if (state?.importType === "single") {
              return navigate(links.walletsImportList);
            }
            return navigate(links.configDuplicationImport);
          }}
        />
      </div>
    </>
  );
};
